import * as React from 'react';
import { useSelector } from 'react-redux';

import { SearchResultsSuccessContainer } from './SearchResultsSuccessContainer';
import { trackEmptyListingShow } from './tracking';
import { selectIsOffersLoading, selectListingOffers } from '../../../common/selectors/listingOffers';
import { selectIsOpen } from '../../../common/selectors/searchResults';
import { IApplicationState } from '../../../common/types/redux';
import { SearchResultsLoading } from '../../components/SearchResults';
import { EmptyListingContainer } from '../EmptyListingContainer';

export const SearchResultsContainer: React.FC = () => {
  const isOpen = useSelector(selectIsOpen);
  const offers = useSelector(selectListingOffers);
  const isLoading = useSelector(selectIsOffersLoading);
  const jsonQuery = useSelector((state: IApplicationState) => state.filters.jsonQuery);
  const queryString = useSelector((state: IApplicationState) => state.queryString);
  const isEmptyListingEventFiredRef = React.useRef(false);

  // Коллбэк для трекинга показа пустого листинга
  const onEmptyListingShow = React.useCallback(() => {
    if (!isEmptyListingEventFiredRef.current && isOpen) {
      trackEmptyListingShow({ jsonQuery, queryString });
      isEmptyListingEventFiredRef.current = true;
    }
  }, [jsonQuery, queryString, isOpen]);

  // Сбрасываем флаг при появлении офферов
  React.useEffect(() => {
    if (offers.length > 0) {
      isEmptyListingEventFiredRef.current = false;
    }
  }, [offers.length]);

  if (!isOpen) {
    return null;
  }

  if (!offers.length && isLoading) {
    return <SearchResultsLoading />;
  }

  if (!offers.length) {
    return <EmptyListingContainer onShow={onEmptyListingShow} />;
  }

  return <SearchResultsSuccessContainer offers={offers} />;
};

SearchResultsContainer.displayName = 'SearchResultsContainer';
